export default __webpack_public_path__ + "static/media/a1.e8e562f7.png";